export default __webpack_public_path__ + "static/media/b2.03048e64.png";